var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupervision(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.593,
    height: 97.924,
    viewBox: "0 0 145.593 97.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-91.198 -60.514)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.688 60.514)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.803 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5582.448,2028.654c-7.852-4.041-32.316-16.126-36.267-18.452-5.258-3.089.172-7.564,3.87-10.746.692-.6,50.16-53.547,64.419-67.521a2.443,2.443,0,0,1,2.661-.475c5.213,2.172,29.031,13.714,37.892,17.626a3.8,3.8,0,0,1,1.923,5.073,3.564,3.564,0,0,1-.788,1.113c-13.079,13.488-61.035,65.1-68.148,72.481A4.731,4.731,0,0,1,5582.448,2028.654Z",
    transform: "translate(-5543.999 -1931.257)",
    fill: "#484242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5545.594,1997.1l62.229-63.661,34.882,16.509-61.537,64.817Z",
    transform: "translate(-5538.093 -1927.197)",
    fill: "#0651f1"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: 17,
    rx: 13.5,
    ry: 17,
    transform: "matrix(0.545, 0.839, -0.839, 0.545, 79.035, 23.905)",
    fill: "#c63d31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.831,787.29c-3.92-6.344,17.533-22.882,21.453-20.527,1.213.75,7.332,3.953,8.47,4.629,6.135.5,14.616-.783,19.327,0,7.31,1.213,25.517,2.663,24.872,9.077-.462,4.566-8.078,2.485-19.023,1.924s-3.3.717-14.737,4.9-19.263,21.878-21.761,17.494c-1.245-1.139-3.288-.9-6.836-2.664a70.253,70.253,0,0,1-7.354-4.408C943.922,797.139,940.192,787.826,939.831,787.29Z",
    transform: "translate(-939.354 -737.888)",
    fill: "#f1cfb5"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M962.01,765.65l18.4,13.688s-12.193,3.279-16.545,14.082c-4.347,10.838-.209,17.574-.209,17.574L938.8,799.98S934.671,773.813,962.01,765.65Z",
    transform: "translate(-847.383 -689.639)",
    fill: "#c63d31"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervision);
export default __webpack_public_path__ + "static/media/supervision.436583a41e2d83efa54b94c5948fef71.svg";
export { ForwardRef as ReactComponent };